import { render } from "./UpdateEmail.vue?vue&type=template&id=2da71f34&ts=true"
import script from "./UpdateEmail.vue?vue&type=script&lang=ts"
export * from "./UpdateEmail.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__